import { Children, Fragment, useState, FC, ReactNode, useCallback } from 'react';

import { IconCollapse } from 'UIPackage/IconsModule/components/IconCollapse';

import styles from './Accordion.module.scss';

interface IAccordionProps {
  mainRow: ReactNode;
}

export const Accordion: FC<IAccordionProps> = ({ mainRow, children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const hasChildren = Children.count(children) > 0;

  const toggleAccordion = useCallback(() => setIsOpen(!isOpen), [isOpen]);

  const iconAttributes = {
    ...(isOpen && { 'data-active': true }),
  };

  return (
    <Fragment>
      <tr className={styles.AccrodionHeadContent}>
        {mainRow}
        {hasChildren && (
          <td className={styles.AccordionIcon} onClick={toggleAccordion}>
            <IconCollapse className={styles.Icon} {...iconAttributes} />
          </td>
        )}
      </tr>
      {isOpen && children}
    </Fragment>
  );
};
